// apps/web/src/routes/(showcase)/showcase/booking.confirmed.$bookingId.tsx
import { createFileRoute, Link } from "@tanstack/react-router";
import { BookingConfirmation } from "~/components/showcase/calendar/booking-confirmation";
import { getBookingFn } from "~/lib/showcase/api-client";
import * as m from "~/paraglide/messages.js";

export const Route = createFileRoute(
  "/(showcase)/showcase/booking_/confirmed/$bookingId"
)({
  component: BookingConfirmedPage,
  head: () => ({
    meta: [
      { title: m.meta_showcase_confirmation_title() },
      { content: "noindex, follow", name: "robots" },
    ],
  }),
  loader: async ({ params }) => {
    const booking = await getBookingFn({
      data: { bookingId: params.bookingId },
    });
    return { booking };
  },
});

function BookingConfirmedPage() {
  const { booking } = Route.useLoaderData();

  if (!booking) {
    return (
      <section className="mx-auto max-w-xl px-4 py-16 text-center">
        <p className="text-[var(--sc-muted)]">
          {m.showcase_confirmation_not_found()}
        </p>
        <Link className="mt-4 inline-block underline" to="/showcase/booking">
          {m.showcase_confirmation_cta_back()}
        </Link>
      </section>
    );
  }

  return <BookingConfirmation booking={booking} />;
}
